import { useState, useEffect } from "react";

const navStyle = (scrolled) => ({
  position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
  display: "flex", alignItems: "center", justifyContent: "space-between",
  padding: "1.25rem 3rem",
  background: "rgba(255,255,255,0.92)",
  backdropFilter: "blur(12px)",
  borderBottom: "1px solid var(--border)",
  boxShadow: scrolled ? "0 1px 20px rgba(0,0,0,0.06)" : "none",
  transition: "box-shadow 0.3s ease",
});

export default function Navbar({ name }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = ["About", "Work", "Experience", "Contact"];

  return (
    <nav style={navStyle(scrolled)}>
      <a href="#home" style={{ fontFamily: "var(--serif)", fontSize: "1.2rem", letterSpacing: "-0.02em", color: "var(--text-main)" }}>
        {name}
      </a>

      {/* Desktop links */}
      <ul style={{ display: "flex", gap: "2rem", alignItems: "center" }} className="nav-desktop">
        {links.map((l) => (
          <li key={l}>
            <a
              href={`#${l.toLowerCase()}`}
              style={{
                fontSize: "0.875rem", color: l === "Contact" ? "var(--white)" : "var(--text-secondary)",
                letterSpacing: "0.02em", transition: "color 0.2s",
                ...(l === "Contact" ? {
                  background: "var(--text-main)", padding: "0.5rem 1.25rem",
                  borderRadius: "999px",
                } : {}),
              }}
            >
              {l}
            </a>
          </li>
        ))}
      </ul>

      {/* Mobile hamburger */}
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        style={{ display: "none", background: "none", border: "none", cursor: "pointer", padding: "4px" }}
        className="nav-mobile-btn"
        aria-label="Toggle menu"
      >
        <span style={{ display: "block", width: 22, height: 2, background: "var(--text-main)", marginBottom: 5, borderRadius: 2 }} />
        <span style={{ display: "block", width: 22, height: 2, background: "var(--text-main)", marginBottom: 5, borderRadius: 2 }} />
        <span style={{ display: "block", width: 22, height: 2, background: "var(--text-main)", borderRadius: 2 }} />
      </button>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{
          position: "absolute", top: "100%", left: 0, right: 0,
          background: "var(--white)", borderBottom: "1px solid var(--border)",
          padding: "1rem 2rem", display: "flex", flexDirection: "column", gap: "1rem",
        }}>
          {links.map((l) => (
            <a key={l} href={`#${l.toLowerCase()}`} onClick={() => setMenuOpen(false)}
              style={{ fontSize: "1rem", color: "var(--text-secondary)", padding: "0.25rem 0" }}>
              {l}
            </a>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-mobile-btn { display: block !important; }
        }
      `}</style>
    </nav>
  );
}
